import React, { ReactNode } from 'react';
import {
  BaseStepperProvider,
  useBaseStepperContext,
  BaseStepperContextValue,
} from '../../shared/contexts/BaseStepperContext';

// NewAccountStepper uses the same interface as the base stepper
export type NewAccountStepperContextValue = BaseStepperContextValue;

// Re-export the base hook with a more specific name for this context
export const useNewAccountStepperContext = useBaseStepperContext;

interface NewAccountStepperProviderProps {
  children: ReactNode;
  value: NewAccountStepperContextValue;
}

export const NewAccountStepperProvider: React.FC<
  NewAccountStepperProviderProps
> = ({ children, value }) => {
  return <BaseStepperProvider value={value}>{children}</BaseStepperProvider>;
};
